import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 10\" id=\"icon-plus\"><path d=\"M3.78.77h1.96v3.26H9v1.96H5.74v3.24H3.78V5.99H.54V4.03h3.24V.77Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol